export default {
  default: () => import("/var/www/apps/front-office/layouts/default.vue").then(m => m.default || m)
}